/* eslint react/forbid-prop-types: 0 */
import React from "react";
import PropTypes from "prop-types";
import { SortableElement, SortableHandle } from "react-sortable-hoc";
import { Glyphicon, Button, Modal } from "react-bootstrap";

const DragHandle = SortableHandle(() => <Glyphicon glyph="resize-vertical" />);

const AddressDisplay = ({ address }) => {
  const { number, street, suburb, postcode, state } = address;
  return (
    <span>
      {" "}
      | {number} {street}, {suburb} {postcode} {state}
    </span>
  );
};
AddressDisplay.propTypes = {
  address: PropTypes.object.isRequired
};

class SortableJobItem extends React.Component {
  state = {
    show: false
  };

  handleShow = () => {
    this.setState({ show: true });
  };

  handleClose = () => {
    this.setState({ show: false });
  };

  handleRemoveJob = () => {
    this.props.removeJob(this.props.job);
    this.setState({ show: false });
  };

  render() {
    const {
      job,
      listItemClassName,
      changeActiveJob,
      removable
    } = this.props;
    const jobName =
      job.customerName || "Please fill in all job and item details";
    let addressString = "";
    if (job.stop.location.address) {
      const { address } = job.stop.location;
      addressString = <AddressDisplay address={address} />;
    }

    let activeJob;
    if (job.externalId) {
      activeJob = { key: "externalId", value: job.externalId };
    } else {
      activeJob = { key: "id", value: job.id };
    }
    return (
      <div
        className={listItemClassName}
        onClick={() => changeActiveJob(activeJob)}
        role="button"
        tabIndex={0}
      >
        <div className="flex-displayx">
          <div
            className="item-basis"
            style={{ display: "inline-block", width: 20 }}
          >
            <DragHandle />
          </div>
          <div
            className="item-basis"
            style={{ display: "inline-block", width: 20 }}
          >
            <span>{job.seq}</span>
          </div>
          <div style={{ display: "inline-block" }}>
            <span>{jobName}</span>
            {addressString}
            {job.type ? ` | ${job.type}` : ""}
          </div>
          <div className="pull-right">
            {removable ? (
              <Button
                bsStyle="danger"
                bsSize="xsmall"
                onClick={this.handleShow}
              >
                <Glyphicon glyph="trash" />
              </Button>
            ) : (
              ""
            )}
          </div>
        </div>
        <Modal show={this.state.show} onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Remove Job</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>
              Are you sure you want to remove this job? This action cannot be
              undone
            </p>
          </Modal.Body>
          <Modal.Footer>
            <span className="pull-left">
              <Button onClick={this.handleClose}>Close</Button>
            </span>
            <Button bsStyle="danger" onClick={this.handleRemoveJob}>
              Remove Job
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
SortableJobItem.propTypes = {
  job: PropTypes.object.isRequired,
  listItemClassName: PropTypes.string.isRequired,
  removeJob: PropTypes.func.isRequired,
  changeActiveJob: PropTypes.func.isRequired,
  removable: PropTypes.bool.isRequired
}

const JobListItem = SortableElement(
  ({ job, listItemClassName, changeActiveJob, removeJob, removable }) => (
    <SortableJobItem
      job={job}
      listItemClassName={listItemClassName}
      changeActiveJob={changeActiveJob}
      removeJob={removeJob}
      removable={removable}
    />
  )
);

export default JobListItem;



// WEBPACK FOOTER //
// ./src/components/jobs/JobSortListItem.js